import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { Link } from 'react-router-dom';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// Custom gold marker
const goldIcon = new L.DivIcon({
    className: 'custom-marker',
    html: `<div style="background: #C8A86B; width: 24px; height: 24px; border-radius: 50%; border: 3px solid white; box-shadow: 0 2px 8px rgba(0,0,0,0.3);"></div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12],
});

// Component to fit bounds
const FitBounds = ({ spas }) => {
    const map = useMap();
    
    useEffect(() => {
        if (spas.length > 0) {
            const bounds = L.latLngBounds(spas.map(spa => [spa.latitude, spa.longitude]));
            map.fitBounds(bounds, { padding: [50, 50] });
        }
    }, [map, spas]);
    
    return null;
};

const MapView = ({ spas, singleSpa = false, height = '400px' }) => {
    const center = singleSpa && spas.length === 1 
        ? [spas[0].latitude, spas[0].longitude]
        : [12.9716, 77.5946]; // Bangalore center
    
    const zoom = singleSpa ? 15 : 12;

    return (
        <div 
            className="map-container rounded-2xl overflow-hidden border border-[#E0DAD0]" 
            style={{ height }}
            data-testid="map-view"
        >
            <MapContainer
                center={center}
                zoom={zoom}
                style={{ height: '100%', width: '100%' }}
                scrollWheelZoom={false}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                />
                {!singleSpa && <FitBounds spas={spas} />}
                {spas.map((spa) => (
                    <Marker 
                        key={spa.id} 
                        position={[spa.latitude, spa.longitude]}
                        icon={goldIcon}
                    >
                        <Popup className="spa-popup">
                            <div className="p-1 min-w-[200px]">
                                <img 
                                    src={spa.images[0]} 
                                    alt={spa.name}
                                    className="w-full h-24 object-cover rounded-lg mb-2"
                                />
                                <h4 className="font-heading text-base text-[#4A4E4D] mb-1">
                                    {spa.name}
                                </h4>
                                <p className="text-xs text-[#4A4E4D]/60 mb-2">{spa.area}</p>
                                <div className="flex items-center justify-between">
                                    <span className="text-xs font-medium text-[#C8A86B]">
                                        ★ {spa.rating}
                                    </span>
                                    <Link 
                                        to={`/spa/${spa.id}`}
                                        className="text-xs text-[#C8A86B] hover:underline"
                                    >
                                        View Details →
                                    </Link>
                                </div>
                            </div>
                        </Popup>
                    </Marker>
                ))}
            </MapContainer>
        </div>
    );
};

export default MapView;
